module.exports = __webpack_public_path__ + "static/media/main idea.f08f8682.mp3";